import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import apkBadgeImg from '../images/apk-badge.svg';

const StoreButtons = ({
  showAndroidBtn,
  showIBtn,
  language,
  trackEventForDownload
}) => (
  <React.Fragment>
    {showIBtn && (
      <a
        href="https://itunes.apple.com/us/app/psngr-mileage-tracker/id871087584"
        target="_blank"
        rel="noopener noreferrer"
        className="action appStoreLink storeLinkBtn"
        onClick={() => trackEventForDownload('ios')}
      >
        <img
          alt="Get it on App Store"
          src={`/images/landing/AppStoreBadge${language.toUpperCase()}.svg`}
        />
      </a>
    )}
    {showAndroidBtn && (
      <Link
        to="/android-download"
        className="action playStoreLink storeLinkBtn"
        onClick={() => trackEventForDownload('android')}
      >
        <img alt="Download Psngr APK for Android" src={apkBadgeImg} />
      </Link>
    )}
  </React.Fragment>
);

StoreButtons.propTypes = {
  showAndroidBtn: PropTypes.bool,
  showIBtn: PropTypes.bool,
  language: PropTypes.string,
  trackEventForDownload: PropTypes.func
};

StoreButtons.defaultProps = {
  showAndroidBtn: true,
  showIBtn: true,
  language: 'en',
  trackEventForDownload: () => {}
};

export default StoreButtons;
